import type { StripeElementsOptions } from "@stripe/stripe-js";

const STRIPE_PUBLIC_KEY_BY_COUNTRY_MAP = {
  us: "stripe_us_public_key",
  gb: "stripe_uk_public_key",
  au: "stripe_au_public_key",
  ca: "stripe_ca_public_key",
  de: "stripe_eu_public_key",
  fr: "stripe_eu_public_key",
  es: "stripe_eu_public_key",
};

const KLARNA_SUPPORTED_CURRENCIES = new Set([
  "eur",
  "dkk",
  "gbp",
  "nok",
  "sek",
  "usd",
  "czk",
  "ron",
  "aud",
  "nzd",
  "cad",
  "pln",
  "chf",
]);

const KLARNA_SUPPORTED_COUNTRIES = new Set([
  "at",
  "be",
  "de",
  "dk",
  "es",
  "fi",
  "gb",
  "ie",
  "it",
  "nl",
  "no",
  "se",
  "us",
  "fr",
  "cz",
  "ro",
  "ee",
  "gr",
  "lv",
  "lt",
  "sk",
  "si",
  "hr",
  "lu",
  "cy",
  "mt",
  "au",
  "nz",
  "ca",
  "pl",
  "pt",
  "ch",
]);

const STRIPE_PAYMENT_ELEMENT_FONTS: StripeElementsOptions["fonts"] = [
  {
    family: "ABCSocial",
    src: "url('https://fonts.peerspace.com/ABCSocial/ABCSocial-Book.otf')",
    weight: "350",
  },
  {
    family: "ABCSocial",
    src: "url('https://fonts.peerspace.com/ABCSocial/ABCSocial-Medium.otf')",
    weight: "500",
  },
];

const STRIPE_PAYMENT_ELEMENT_STYLES: StripeElementsOptions["appearance"] = {
  theme: "stripe" as "stripe" | "night" | "flat",
  variables: {
    fontSizeSm: "14px",
    fontWeightNormal: "350",
    fontLineHeight: "16px",
    fontFamily: "ABCSocial, Helvetica Neue, Helvetica, Arial, sans-serif",
    colorPrimary: "#121212",
    colorText: "#121212",
    colorTextSecondary: "#121212",
  },
  rules: {
    ".PaymentMethodMessaging": {
      textAlign: "center",
    },
  },
};

export {
  STRIPE_PUBLIC_KEY_BY_COUNTRY_MAP,
  KLARNA_SUPPORTED_CURRENCIES,
  KLARNA_SUPPORTED_COUNTRIES,
  STRIPE_PAYMENT_ELEMENT_FONTS,
  STRIPE_PAYMENT_ELEMENT_STYLES,
};
